export default function DepartmentResourcesDirective() {
  return {
    template: require('./department-resources.html'),
    scope: {
      resources: '=',
    },
    controller: 'DepartmentResourcesController',
    controllerAs: 'departmentResourcesVM',
    bindToController: true,
    replace: true,
  };
}
